export const SkeletonClaimLoad = () => {

    return (
        <main className="container text-center mb-5">

            <div className="row">
                <div className="col-12">
                    <img src="/brand.png" alt="brand" className="brand" />
                </div>
            </div>

            <div className="row">
                <div className="col-12 mb-2">
                    <h2>Unit Costs Claim Form</h2>
                </div>
            </div>

            <div className="row">

                <div className="col-12 col-md-8 order-2 order-md-1">

                    <div className="card">
                        <div className="card-header">
                            Travel | Accommodation Calculator
                        </div>
                        <div className="card-body text-start">

                            <div className="row placeholder-glow px-2">
                                <span className="col-12 mb-1 p-0"><label className="fw-bold">Nights spent</label></span>
                                <span className="placeholder col-12 mb-3 rounded"></span>

                                <span className="col-12 mb-1 p-0"><label className="fw-bold">Travel Type</label></span>
                                <span className="placeholder col-12 mb-3 rounded"></span>
                            </div>

                            <hr />

                            <div className="row placeholder-glow px-2">

                                <span className="col-12 mb-1 p-0"><label className="fw-bold">Place of employment</label></span>
                                <span className="placeholder col-12 mb-3 rounded"></span>

                                <span className="col-12 mb-1 p-0"><label className="fw-bold">Institution / Company</label></span>
                                <span className="placeholder col-12 mb-3 rounded"></span>

                                <span className="col-12 mb-1 p-0"><label className="fw-bold">Street</label></span>
                                <span className="placeholder col-12 mb-3 rounded"></span>

                                <span className="col-12 mb-1 p-0"><label className="fw-bold">Postal Code</label></span>
                                <span className="placeholder col-12 mb-3 rounded"></span>

                                <span className="col-12 mb-1 p-0"><label className="fw-bold">City</label></span>
                                <span className="placeholder col-12 mb-3 rounded"></span>

                                <span className="col-12 mb-1 p-0"><label className="fw-bold">Country</label></span>
                                <span className="placeholder col-12 mb-3 rounded"></span>

                            </div>

                            <hr />

                            <div className="row placeholder-glow px-2">
                                <button disabled className="btn btn-primary">Calculate contribution</button>
                            </div>

                        </div>
                    </div>

                </div>

                <div className="col-12 col-md-4 order-1 order-md-2">

                    <div className="card">
                        <div className="card-header">
                            Event Details
                        </div>
                        <div className="card-body text-start">

                            <div className="row placeholder-glow px-2">

                                <span className="col-12 mb-1 p-0"><label className="fw-bold">Event Title</label></span>
                                <span className="placeholder col-12 mb-3 rounded"></span>

                                <span className="col-12 mb-1 p-0"><label className="fw-bold">Event Number</label></span>
                                <span className="placeholder col-12 mb-3 rounded"></span>

                                <span className="col-12 mb-1 p-0"><label className="fw-bold"><i className="bi bi-calendar me-1"></i>Seminar Start Date</label></span>
                                <span className="placeholder col-12 mb-3 rounded"></span>

                                <span className="col-12 mb-1 p-0"><label className="fw-bold"><i className="bi bi-calendar me-1"></i>Seminar End Date</label></span>
                                <span className="placeholder col-12 mb-3 rounded"></span>

                                <span className="col-12 mb-1 p-0"><label className="fw-bold"><i className="bi bi-geo me-1"></i>Event Location</label></span>
                                <span className="placeholder col-12 mb-3 rounded"></span>

                            </div>

                        </div>
                    </div>

                    <div className="card mt-2">
                        <div className="card-header">
                            Contact
                        </div>
                        <div className="card-body text-start">

                            <div className="row mb-2">
                                <div className="col-12 col-md-4">
                                    <img src="/default-avatar.png" className="img-thumbnail" alt="imgPlaceholder" />
                                </div>
                                <div className="col-12 col-md-8">

                                    <div className="row placeholder-glow px-2">

                                        <span className="placeholder col-12 mb-3 rounded"></span>
                                        <span className="placeholder col-12 mb-3 rounded"></span>
                                        <span className="placeholder col-12 mb-3 rounded"></span>
                                        <span className="placeholder col-12 mb-3 rounded"></span>

                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>

                </div>

            </div>


        </main>
    )
}